import firebase from "firebase/compat/app";

export async function sendPasswordResetEmail(email: string, lang: string): Promise<void> {
  firebase.auth().languageCode = lang;
  return await firebase.auth().sendPasswordResetEmail(email);
}
